export enum PuzzleGameTypesEnum {
  CrosswordPuzzle = 'swedish',
  ImagePuzzle = 'imagePuzzle',
  SudokuGame = 'sudoku',
  WordSearchPuzzle = 'wordSearchPuzzle',
  WordGuessPuzzle = 'wordGuessPuzzle',
  QuizGame = 'quiz',
  BridgesGame = 'bridges',
}
